<template>
  <div class="container">
    <div>{{msg}}</div>
    <div>{{propData}}</div>
  </div>
</template>

<script>
  export default {
    name: 'npmpractice',
    data() {
      return {
        msg: '我这个是npm测试组件'
      }
    },
    props: {
      propData: {
        type: String,
        default: '我是默认值'
      }
    }
  }
</script>

<style scoped="scoped">
  .container {
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/npmpractice.vue